import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import {BASE_API_URL } from '../config/app.config'
import { ParkProvider } from '@providers/park.provider'

@Injectable()
export class TaskProvider {

  constructor(private http: HttpClient) {}

  async getTasks(options: any = {}) {
    const url = BASE_API_URL + 'task';
    let queryParams = new HttpParams();

    let tasks: any[];

    if (options.area) {
      queryParams = queryParams.append('area', options.area);
    }

    if (options.status) {
      queryParams = queryParams.append('status', options.status);
    }

    await this.http.get<any>(url, {
      params: queryParams
    }).toPromise().then(async (res: any[]) => {
      tasks = res;
    });

    return await tasks;
  }
}


// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/providers/task.provider.ts